import { IItemState } from '@/store/item';
import { IItemMutations } from './mutations.types';
import { IItemData } from '@/models';

export const mutations: IItemMutations = {
  SET_ITEMS(state: IItemState, payload: IItemData[]): void {
    state.items = payload;
  },

  ADD_ITEM(state: IItemState, payload: IItemData): void {
    state.items.push(payload);
  },

  UPDATE_ITEM(state: IItemState, payload: IItemData): void {
    const index = state.items.findIndex(
      (item: IItemData) => item.item === payload.item
    );

    state.items.splice(index, 1, payload);
  },

  REMOVE_ITEM(state: IItemState, payload: string): void {
    const index = state.items.findIndex(
      (item: IItemData) => item.item === payload
    );

    state.items.splice(index, 1);
  },

  SET_COUNT(state: IItemState, payload: number): void {
    state.count = payload;
  },

  INCREMENT_COUNT(state: IItemState): void {
    state.count += 1;
  },

  DECREMENT_COUNT(state: IItemState): void {
    state.count -= 1;
  }
};
